export default __webpack_public_path__ + "static/media/farmGameIcon.731281c1.png";